<template>
  <SectionWrapper sectionId="collaborator">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading"/>
      <ContentContainer>
        <div class="collaborator-container">
          <CollaboratorCard
            v-for="(collaborator, index) in collaboratorList"
            :key="index"
            class="collaborator-item"
            :collaboratorType="collaborator.type"
            :name="collaborator.name"
            :categoryType="collaborator.categoryType"
            :logoSrc="collaborator.logoSrc"
            :href="collaborator.href" />
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import CollaboratorCard from '../atoms/CollaboratorCard'

export default {
  name: 'collaborator',
  data () {
    return {
      headingData: {
        img: require('@/assets/images/title_collaborator.svg'),
        text: 'collaborator',
        leading: 'コラボレーター'
      },
      collaboratorList: [
        {
          type: 'Slalom',
          name: 'Slalom',
          categoryType: 'ビジネス',
          logoSrc: require('@/assets/images/logo_slalom.png'),
          href: 'https://www.slalom.com'
        },
        {
          type: 'Goodpatch',
          name: '株式会社グッドパッチ',
          categoryType: 'デザイン',
          logoSrc: require('@/assets/images/logo_goodpatch.svg'),
          href: 'https://goodpatch.com'
        }
      ]
    }
  },
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    CollaboratorCard
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/mixins';

.collaborator {
  &-container {
    display: flex;
    @include bpOnlyPc() {
      flex-direction: row;
      justify-content: center;
    }
    @include bpOnlySp() {
      flex-direction: column;
      align-items: center;
    }
  }
  &-item {
    &:last-of-type {
      @include bpOnlyPc() {
        margin-left: 30px;
      }
      @include bpOnlySp() {
        margin-top: 30px;
      }
    }
  }
}
</style>
